import { z } from 'zod';
import { AssetApi } from '@/pages/Inventory/pages/Assets/models/Assets';

export interface UserApi {
  id: string;
  fullName: string;
  email: string;
  phone: string;
  address: string;
  status?: UserStatus;
  createdAt: string;
  assets?: AssetApi[];
}

export enum UserStatus {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
}

export interface UsersFilter {
  fullName: string;
  email: string;
  phone?: string;
  status?: UserStatus;
}

export const createUserSchema = z.object({
  fullName: z
    .string()
    .min(3, 'Mínimo 3 caracteres')
    .max(25, 'Máximo 25 caracteres'),
  email: z
    .string()
    .min(1, 'Debe ingresar un correo electronico')
    .email('Debe ser un correo válido'),
  phone: z.string().min(6, 'Debe ingresar un teléfono válido'),
  address: z.string().min(3, 'Debe ingresar una dirección válida'),
  status: z
    .enum([UserStatus.ENABLED, UserStatus.DISABLED])
    .optional()
    .default(UserStatus.ENABLED),
});

export type CreateUserSchema = z.infer<typeof createUserSchema>;

export const defaultValues: CreateUserSchema = {
  fullName: '',
  email: '',
  phone: '',
  address: '',
  status: UserStatus.ENABLED,
};
